export default class UserRoleLevel {
  static SUPERADMIN = 1
  static COORDINATOR = 2
  static EMPLOYEE = 3
}

UserRoleLevel[UserRoleLevel.SUPERADMIN] = 'Quản trị viên'
UserRoleLevel[UserRoleLevel.COORDINATOR] = 'Điều phối viên'
UserRoleLevel[UserRoleLevel.EMPLOYEE] = 'Nhân viên'